import apiServices from "../../../../../services/apiServices";
import eventBus from "../../../../main";
export default {
  actions: {
    sendMessageToOpenTicket(context, payload) {
      eventBus.$emit("openSpin", true);
      apiServices
        .sendMessageToOpenTickets(payload)
        .then(function(response) {
          if (response.status === 201) {
            let payload = {
              color: "success",
              text: "Solicitação enviada com sucesso!",
              errorLogin: true
            };
            eventBus.$emit("openInfo", payload);
          } else {
            let payload = {
              color: "error",
              text: "Ups! Seu pedido não foi processado. Tente mais tarde",
              errorLogin: true
            };
            eventBus.$emit("openInfo", payload);
          }
        })
        .catch(function() {
          let payload = {
            color: "error",
            text: "Ups! seu pedido não foi processado",
            errorLogin: true
          };
          eventBus.$emit("openInfo", payload);
        })
        .finally(function() {
          eventBus.$emit("openSpin", false);
        });
    }
  }
};
